import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const rangeOptions = useSelector((state) => state.laser.rangeOptions);
  const selected = useSelector((state) => state.laser.selectedFilters.rangeOption);

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selected}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};
